import React__default from 'react';
import { PopoverTrigger } from './popover-trigger.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

/**
 * PopoverLauncher wraps PopoverTrigger and adds the trigger to the first element. It matches legacy styling by wrapping trigger in a div with a class
 *
 * Only the first child element will be treated as the trigger element
 *
 * The trigger element MUST be a focusable element for A11Y - no plain text or icons
 *
 * @subcomponent Popover
 */ const PopoverLauncher = renderWithRef('PopoverLauncher', null, (props, ref)=>{
    const { children } = props;
    const classNames = [
        'swan-popover-launcher'
    ];
    return /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "span",
        forwardedRef: ref,
        classNames: classNames,
        props: props
    }, /*#__PURE__*/ React__default.createElement(PopoverTrigger, null, children));
});

export { PopoverLauncher };
